import Glide from '@glidejs/glide';
import {
    LoadingClass,
    preventVerticalScroll,
    ArrowDisabler,
} from './glideVisible';

export default function initiateSlider() {
    const sliders = document.querySelectorAll('.glide');
    Object.values(sliders).map((slider) => {
        const track = slider.querySelector('.glide__slides');
        const gap = 15;
        const settings = {
            type: 'slider',
            startAt: 0,

            perView: track.dataset.slidesPerView,
            perTouch: 1,
            bound: true,
            hoverpause: track.dataset.slidesHoverPause,
            animationDuration: track.dataset.slidesDuration,
            rewind: false,
            gap,
            breakpoints: {
                5000: {
                    perView: 4,
                },
                1440: {
                    perView: 4,
                },
                1360: {
                    perView: 3,
                },
                1280: {
                    perView: 3,
                },
                1266: {
                    perView: 3,
                },
                1024: {
                    perView: 3,
                },
                768: {
                    perView: 3,
                },
                575: {
                    perView: 2,
                },
                412: {
                    perView: 2,
                },
                375: {
                    perView: 2,
                },
            },
        };

        const mountSettings = {
            LoadingClass,
            preventVerticalScroll,
            ArrowDisabler,
        };
        const glide = new Glide(slider, settings);
        return glide.mount(mountSettings);
    });
}

window.addEventListener('DOMContentLoaded', initiateSlider);

export function preventButtonsOnFewSlides() {
    const resourceSliderCarousels = document.querySelectorAll(
        '.resource-tile-carousel'
    );

    const mediaQuery = window.matchMedia('(max-width: 1349px)');

    resourceSliderCarousels.forEach((resourceSlider) => {
        const sliderTiles = resourceSlider.querySelectorAll(
            '.resource-tile__container'
        );

        const sliderArrowControls =
            resourceSlider.querySelectorAll('.glide__arrow');

        const controlArrowsMediaQuery = () => {
            for (let j = 0; j < sliderTiles.length; j++) {
                sliderArrowControls.forEach((glideArrowControl) => {
                    if (j < 4) {
                        if (mediaQuery.matches) {
                            glideArrowControl.classList.remove(
                                'hide--controls'
                            );
                        } else {
                            glideArrowControl.classList.add('hide--controls');
                        }
                    } else {
                        glideArrowControl.classList.remove('hide--controls');
                    }
                });
            }
        };

        controlArrowsMediaQuery();

        window.addEventListener('resize', () => {
            controlArrowsMediaQuery();
        });
    });
}

window.addEventListener('DOMContentLoaded', preventButtonsOnFewSlides);
